// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeline {
  position: relative;
  margin: 50px auto;
  margin-bottom: 0px;
  width: 80%;
}

.timeline-line {
  position: absolute;
  left: 50%;
  line-height: 1%;
  width: 2px;
  background: #000000;
}

.timeline-line-center {
  position: absolute;
  width: 100%;
  height: 2px;
  background: #000000;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}

.timeline-items {
  display: flex;
  justify-content: center;
}

.timeline-item {
  width: 40%;
  margin: 4%;
  padding: 2px;
  background-color: #00000093;
  border-radius: 15px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  position: relative;
  opacity: 0;
  transition: opacity 0.5s ease-in 0.2s;
}

.timeline-dot {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #0e0e0e;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1; 
}

.timeline-item.left .timeline-dot {
  right: calc(-15% - 13px);
}

.timeline-item.right .timeline-dot {
  left: calc(-14% - 15px);
}

.timeline-item-content {
  background: #ffffffd7;
  border-radius: 15px;
  padding: 20px;
  position: relative;
}

.timeline-item-content img {
  max-width: 100%;
  height: auto;
  margin-right: 10px;
}

.timeline-item-date {
  font-size: 20px;
  font-weight: bold;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: calc(120% + 10px);
  left: auto;
}

.timeline-item.left .timeline-item-date {
  left: calc(130% + 10px);
  right: auto;
  width: 100%;
  height: 65px;
  color: #000000;
}

.timeline-item.right .timeline-item-date {
  right: calc(55% + 10px);
  left: auto;
  width: 100%;
  height: 65px;
  color: #0e0e0e;
}

.timeline-item-title {
  margin-top: 10px;
  font-size: 24px;
}

.timeline-item-description {
  margin-top: 15px;
  font-size: 18px;
}

.timeline-item.left {
  transform: translateX(-66%);
}

.timeline-item.right {
  transform: translateX(66%);
}

.timeline-item.visible {
  opacity: 1;
}

.timeline-line-to-dot {
  position: absolute;
  width: calc(18% - 2px);
  height: 2px;
  background-color: #0e0e0e;
  opacity: 0;
  transition: opacity 0.6s ;
  z-index: 0;
  top: 50%;
  transform: translateY(-50%) ease-in 0.9; 
}

.timeline-item.left .timeline-line-to-dot {
  right: calc(-18% + 12px);
}

.timeline-item.right .timeline-line-to-dot {
  left: calc(-14% - 2px);
}

.timeline-item.visible .timeline-line-to-dot {
  opacity: 1;
}

.timeline-central-line {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  width: 2px;
  background-color: #0e0e0e;
  z-index: 1;
}

@media only screen and (max-width: 1400px) {
  .timeline {
    position: relative;
    margin: 0px;
    width: 80%;
  }
  .timeline-item {
    width: 40%;
    margin: 0%;
    padding: 0px;
    border: 1px solid black;
    background-color: #00000093;
    border-radius: 16px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
    position: relative;
    opacity: 0;
    transition: opacity 0.5s ease-in 0.2s;
  }
  
  .timeline-line-to-dot {
    position: absolute;
    width: calc(16% - 2px);
  }
  .timeline-line-center {
    width: 1px;
  }
  .timeline-dot {
    width: 15px;
    height: 15px;
    top: 50.2%;
    transform: translateY(-50%);
    z-index: 1; 
  }
  .timeline-central-line {
    top: 0;
    bottom: 0;
    left: 50%;
    width: 1px;
    z-index: 1;
  }
  .timeline-item.left {
    transform: translateX(-66.2%);
  }
  
  .timeline-item.right {
    transform: translateX(66.8%);
  }
  .timeline-item.left .timeline-line-to-dot {
    right: calc(-18% + 9px);
  }
  .timeline-item.right .timeline-line-to-dot {
    left: calc(-14% - 2px);
  }

  .timeline-item.left .timeline-item-date {
    left: calc(130% + 0px);
    width: 100%;
    height: 65px;
  }
  
  .timeline-item.right .timeline-item-date {
    right: calc(55% + 30px);
    width: 100%;
    height: 65px;
  }
  .timeline-item-title {
    margin-top: 10px;
    font-size: 20px;
  }
  .timeline-item-description {
    margin-top: 1px;
    font-size: 18px;
  }
  
  
}

@media only screen and (max-width: 750px) {
  .timeline {
    position: relative;
    margin: 0px;
    width: 100%;
  }
  .timeline-item {
    width: 50%;
    margin: 0%;
    padding: 0px;
    border: 1px solid black;
    background-color: #00000093;
    border-radius: 16px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
    position: relative;
    opacity: 0;
    transition: opacity 0.5s ease-in 0.2s;
  }
  .timeline-item-date{
    font-size: 15px;
    top: 53%;
    transform: translateY(-50%);
    right: calc(120% + 10px);
    left: auto;
  }
  
  .timeline-line-to-dot {
    position: absolute;
    width: calc(16% - 2px);
  }
  .timeline-line-center {
    width: 1px;
  }
  .timeline-dot {
    width: 15px;
    height: 15px;
    top: 50.2%;
    transform: translateY(-50%);
    z-index: 1; 
  }
  .timeline-central-line {
    top: 0;
    bottom: 0;
    left: 50%;
    width: 1px;
    z-index: 1;
  }
  .timeline-item.left {
    transform: translateX(-67%);
  }
  
  .timeline-item.right {
    transform: translateX(68%);
  }
  .timeline-item.left .timeline-line-to-dot {
    right: calc(-18% + 6px);
  }
  .timeline-item.right .timeline-line-to-dot {
    left: calc(-14% - 2px);
  }

  .timeline-item.left .timeline-item-date {
    left: calc(130% + 10px);
    width: 100%;
    height: 65px;
  }
  .timeline-item.right .timeline-item-date {
    right: calc(55% + 60px);
    width: 100%;
    height: 65px;
  }
  .timeline-item-title {
    margin-top: -10px;
    font-size: 16px;
  }
  .timeline-item-description {
    margin-top: 1px;
    font-size: 14px;
  }
  .timeline-item-description-status {
    margin-top: 1px;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: -10px;
  }
  .timeline-item-description-level {
    margin-top: 1px;
    font-size: 14px;
  }
  .timeline-item-description-location {
    margin-top: 1px;
    font-size: 14px;
    font-weight: bold;

  }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Cards/Timelines/education-timeline/timeline.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,QAAQ;EACR,OAAO;EACP,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV,yBAAyB;EACzB,UAAU;EACV,QAAQ;EACR,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;EACA;IACE,UAAU;IACV,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,UAAU;IACV,qCAAqC;EACvC;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,MAAM;IACN,SAAS;IACT,SAAS;IACT,UAAU;IACV,UAAU;EACZ;EACA;IACE,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;EAC9B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,WAAW;IACX,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,eAAe;IACf,eAAe;EACjB;;;AAGF;;AAEA;EACE;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;EACb;EACA;IACE,UAAU;IACV,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,UAAU;IACV,qCAAqC;EACvC;EACA;IACE,eAAe;IACf,QAAQ;IACR,2BAA2B;IAC3B,wBAAwB;IACxB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,MAAM;IACN,SAAS;IACT,SAAS;IACT,UAAU;IACV,UAAU;EACZ;EACA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,WAAW;IACX,YAAY;EACd;EACA;IACE,uBAAuB;IACvB,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;;EAEnB;AACF","sourcesContent":[".timeline {\n  position: relative;\n  margin: 50px auto;\n  margin-bottom: 0px;\n  width: 80%;\n}\n\n.timeline-line {\n  position: absolute;\n  left: 50%;\n  line-height: 1%;\n  width: 2px;\n  background: #000000;\n}\n\n.timeline-line-center {\n  position: absolute;\n  width: 100%;\n  height: 2px;\n  background: #000000;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n}\n\n.timeline-items {\n  display: flex;\n  justify-content: center;\n}\n\n.timeline-item {\n  width: 40%;\n  margin: 4%;\n  padding: 2px;\n  background-color: #00000093;\n  border-radius: 15px;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);\n  position: relative;\n  opacity: 0;\n  transition: opacity 0.5s ease-in 0.2s;\n}\n\n.timeline-dot {\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  background-color: #0e0e0e;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 1; \n}\n\n.timeline-item.left .timeline-dot {\n  right: calc(-15% - 13px);\n}\n\n.timeline-item.right .timeline-dot {\n  left: calc(-14% - 15px);\n}\n\n.timeline-item-content {\n  background: #ffffffd7;\n  border-radius: 15px;\n  padding: 20px;\n  position: relative;\n}\n\n.timeline-item-content img {\n  max-width: 100%;\n  height: auto;\n  margin-right: 10px;\n}\n\n.timeline-item-date {\n  font-size: 20px;\n  font-weight: bold;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: calc(120% + 10px);\n  left: auto;\n}\n\n.timeline-item.left .timeline-item-date {\n  left: calc(130% + 10px);\n  right: auto;\n  width: 100%;\n  height: 65px;\n  color: #000000;\n}\n\n.timeline-item.right .timeline-item-date {\n  right: calc(55% + 10px);\n  left: auto;\n  width: 100%;\n  height: 65px;\n  color: #0e0e0e;\n}\n\n.timeline-item-title {\n  margin-top: 10px;\n  font-size: 24px;\n}\n\n.timeline-item-description {\n  margin-top: 15px;\n  font-size: 18px;\n}\n\n.timeline-item.left {\n  transform: translateX(-66%);\n}\n\n.timeline-item.right {\n  transform: translateX(66%);\n}\n\n.timeline-item.visible {\n  opacity: 1;\n}\n\n.timeline-line-to-dot {\n  position: absolute;\n  width: calc(18% - 2px);\n  height: 2px;\n  background-color: #0e0e0e;\n  opacity: 0;\n  transition: opacity 0.6s ;\n  z-index: 0;\n  top: 50%;\n  transform: translateY(-50%) ease-in 0.9; \n}\n\n.timeline-item.left .timeline-line-to-dot {\n  right: calc(-18% + 12px);\n}\n\n.timeline-item.right .timeline-line-to-dot {\n  left: calc(-14% - 2px);\n}\n\n.timeline-item.visible .timeline-line-to-dot {\n  opacity: 1;\n}\n\n.timeline-central-line {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 50%;\n  width: 2px;\n  background-color: #0e0e0e;\n  z-index: 1;\n}\n\n@media only screen and (max-width: 1400px) {\n  .timeline {\n    position: relative;\n    margin: 0px;\n    width: 80%;\n  }\n  .timeline-item {\n    width: 40%;\n    margin: 0%;\n    padding: 0px;\n    border: 1px solid black;\n    background-color: #00000093;\n    border-radius: 16px;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);\n    position: relative;\n    opacity: 0;\n    transition: opacity 0.5s ease-in 0.2s;\n  }\n  \n  .timeline-line-to-dot {\n    position: absolute;\n    width: calc(16% - 2px);\n  }\n  .timeline-line-center {\n    width: 1px;\n  }\n  .timeline-dot {\n    width: 15px;\n    height: 15px;\n    top: 50.2%;\n    transform: translateY(-50%);\n    z-index: 1; \n  }\n  .timeline-central-line {\n    top: 0;\n    bottom: 0;\n    left: 50%;\n    width: 1px;\n    z-index: 1;\n  }\n  .timeline-item.left {\n    transform: translateX(-66.2%);\n  }\n  \n  .timeline-item.right {\n    transform: translateX(66.8%);\n  }\n  .timeline-item.left .timeline-line-to-dot {\n    right: calc(-18% + 9px);\n  }\n  .timeline-item.right .timeline-line-to-dot {\n    left: calc(-14% - 2px);\n  }\n\n  .timeline-item.left .timeline-item-date {\n    left: calc(130% + 0px);\n    width: 100%;\n    height: 65px;\n  }\n  \n  .timeline-item.right .timeline-item-date {\n    right: calc(55% + 30px);\n    width: 100%;\n    height: 65px;\n  }\n  .timeline-item-title {\n    margin-top: 10px;\n    font-size: 20px;\n  }\n  .timeline-item-description {\n    margin-top: 1px;\n    font-size: 18px;\n  }\n  \n  \n}\n\n@media only screen and (max-width: 750px) {\n  .timeline {\n    position: relative;\n    margin: 0px;\n    width: 100%;\n  }\n  .timeline-item {\n    width: 50%;\n    margin: 0%;\n    padding: 0px;\n    border: 1px solid black;\n    background-color: #00000093;\n    border-radius: 16px;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);\n    position: relative;\n    opacity: 0;\n    transition: opacity 0.5s ease-in 0.2s;\n  }\n  .timeline-item-date{\n    font-size: 15px;\n    top: 53%;\n    transform: translateY(-50%);\n    right: calc(120% + 10px);\n    left: auto;\n  }\n  \n  .timeline-line-to-dot {\n    position: absolute;\n    width: calc(16% - 2px);\n  }\n  .timeline-line-center {\n    width: 1px;\n  }\n  .timeline-dot {\n    width: 15px;\n    height: 15px;\n    top: 50.2%;\n    transform: translateY(-50%);\n    z-index: 1; \n  }\n  .timeline-central-line {\n    top: 0;\n    bottom: 0;\n    left: 50%;\n    width: 1px;\n    z-index: 1;\n  }\n  .timeline-item.left {\n    transform: translateX(-67%);\n  }\n  \n  .timeline-item.right {\n    transform: translateX(68%);\n  }\n  .timeline-item.left .timeline-line-to-dot {\n    right: calc(-18% + 6px);\n  }\n  .timeline-item.right .timeline-line-to-dot {\n    left: calc(-14% - 2px);\n  }\n\n  .timeline-item.left .timeline-item-date {\n    left: calc(130% + 10px);\n    width: 100%;\n    height: 65px;\n  }\n  .timeline-item.right .timeline-item-date {\n    right: calc(55% + 60px);\n    width: 100%;\n    height: 65px;\n  }\n  .timeline-item-title {\n    margin-top: -10px;\n    font-size: 16px;\n  }\n  .timeline-item-description {\n    margin-top: 1px;\n    font-size: 14px;\n  }\n  .timeline-item-description-status {\n    margin-top: 1px;\n    font-size: 14px;\n    font-weight: bold;\n    margin-bottom: -10px;\n  }\n  .timeline-item-description-level {\n    margin-top: 1px;\n    font-size: 14px;\n  }\n  .timeline-item-description-location {\n    margin-top: 1px;\n    font-size: 14px;\n    font-weight: bold;\n\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
